import { ref } from "vue";
import { defineStore } from "pinia";
import { User } from "@/app/security/models/SecurityModel";

export const useAuth = defineStore(
  "auth",
  () => {
    const user = ref(new User());
    const accessToken = ref("");
    const refreshToken = ref("");

    function setUser(value: User) {
      user.value = new User(value);
    }

    function setAccessToken(value: string) {
      accessToken.value = value;
    }

    function setRefreshToken(value: string) {
      refreshToken.value = value;
    }

    function clearAuth() {
      accessToken.value = undefined;
      refreshToken.value = undefined;
      user.value = new User();
    }

    return {
      user,
      accessToken,
      refreshToken,
      setUser,
      setAccessToken,
      setRefreshToken,
      clearAuth,
    };
  },
  {
    persist: {
      storage: sessionStorage,
    },
  },
);
